export enum PaymentType {
    Efectivo = 0,
    Credito = 1,
    Debito = 2
}
